<script setup>
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import AppHeader from "@/layout/AppHeader.vue";
import AppFooter from "@/layout/AppFooter.vue";

// Components
import HeroSection from "@/components/Home/HeroSection.vue";
import AdvantageSection from "@/components/Home/AdvantageSection.vue";
import FeaturesSection from "@/components/Home/FeaturesSection.vue";
import ProcessSection from "@/components/Home/ProcessSection.vue";
import TargetAudienceSection from "@/components/Home/TargetAudienceSection.vue";
import StatsSection from "@/components/Home/StatsSection.vue";
import FeedbackSection from "@/components/Home/FeedbackSection.vue";
import RecommendSection from "@/components/Home/RecommendSection.vue";

const route = useRoute();

// UTM Data Parsing
const parseUTMData = () => {
  let utm_source = "";
  let utm_medium = "";
  let utm_content = "";

  if (route.query.utm_source != undefined) {
    utm_source = decodeURI(route.query.utm_source);
  }
  if (route.query.utm_medium != undefined) {
    utm_medium = decodeURI(route.query.utm_medium);
  }
  if (route.query.utm_content != undefined) {
    utm_content = decodeURI(route.query.utm_content);
  }
  if (utm_source == "" && utm_medium == "" && utm_content == "") {
    return null;
  } else {
    let utm_ref = utm_source + "_" + utm_medium + "_" + utm_content;
    localStorage.utm_ref = utm_ref;
    return utm_ref;
  }
};

onMounted(() => {
  parseUTMData();
  console.log("utm_ref:", localStorage.utm_ref);
});
</script>

<template>
  <AppHeader />
  <div class="home-container">
    <HeroSection />
    <AdvantageSection />
    <FeaturesSection />
    <ProcessSection />
    <TargetAudienceSection />
    <StatsSection />
    <FeedbackSection />
    <RecommendSection />
  </div>
  <AppFooter />
</template>

<style scoped>
/* ================= Common & Defaults (Mobile First) ================= */
/* Most styles have been moved to sub-components. */
/* Keeping global container if any specific style needed, currently none evident but good to have class hook */
</style>
